import React, { PureComponent } from 'react';
import { ContentTypeKeys } from '../../molecules/ContentListSelector';
import { ContentListHeader } from '../../organisms/ContentListHeader';
import { ContentList, ContentExcerpt } from '../../organisms/ContentList';
import { Container } from './elements';
import { Purchase } from '../../../domain/entities';
import { Toast } from '../../molecules/Toast';
import { words } from '../../../constants';

import PurchaseModal from './PurchaseModal';

type Props = {
  userPoints: number;
  contentTitle: string;
  // contents: { [key: string]: ContentExcerpt };
  contents: ContentExcerpt[];
  selectedType: ContentTypeKeys;
  userId: string;
  purchases: { [key: string]: Purchase };
  contentTypes: { [key: string]: string };
  isFetchingVideos: boolean;
  isFetchingProjectContents: boolean;
  isFetchingEAPrograms: boolean;
  isPurchasingContent: boolean;
  isFetchingVideoByIdFromContent: boolean;
  purchaseItem?: Purchase & { pointRefund?: number };
  isDownloadingProjectContent?: boolean;
  isDownloadingEAContent?: boolean;
  isFetchingPurchases: boolean;
  isFetchingUser: boolean;
  isFetchingProjectContentById: boolean;
  isFetchingEAById: boolean;
  onSelectContentType: (contentType: ContentTypeKeys) => void;
  onPressPurchase: (id: string, url?: string, filename?: string) => void;
  onPressPurchasePoints: () => void;
  navigateToManualContentViewer: (manualId: string) => void;
  onDownloadFile: (url: string, filename: string) => void;
  getUser: (id: string) => void;
  fetchPurchases: (userId: string) => void;
  getVideoByIdFromContent: (id: string) => void;
  getProjectContentById: (id: string) => void;
  getEAById: (id: string) => void;
};

type State = {
  isPurchaseModalVisible: boolean;
  selectedContentId?: string;
  isPurchased: boolean;
  toastTime?: number;
  toastTitle?: string;
  selectedDownloadContent?: string;
};

export default class Contents extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isPurchaseModalVisible: false,
      isPurchased: false,
    };
  }

  componentDidUpdate(prevProps: Props) {
    const {
      purchaseItem,
      selectedType,
      isDownloadingProjectContent,
      isDownloadingEAContent,
      isFetchingPurchases,
      isFetchingUser,
      getVideoByIdFromContent,
      isFetchingVideoByIdFromContent,
      getProjectContentById,
      isFetchingProjectContentById,
      getEAById,
      isFetchingEAById,
    } = this.props;
    const {
      selectedContentId,
      isPurchaseModalVisible,
      selectedDownloadContent,
    } = this.state;

    if (
      prevProps.isFetchingPurchases !== isFetchingPurchases &&
      !isFetchingPurchases &&
      !!selectedContentId
    ) {
      this.handleOnPressPurchase(selectedContentId);
    }

    if (
      isPurchaseModalVisible &&
      selectedDownloadContent === selectedContentId &&
      ((prevProps.isDownloadingProjectContent &&
        !isDownloadingProjectContent) ||
        (prevProps.isDownloadingEAContent && !isDownloadingEAContent))
    ) {
      this.setState({ isPurchaseModalVisible: false });
    }

    if (
      purchaseItem &&
      prevProps.purchaseItem?.id !== purchaseItem.id &&
      purchaseItem.pointRefund &&
      Number(purchaseItem.pointRefund) > 0 &&
      selectedType !== 'pastVideos'
    ) {
      this.setToastState(purchaseItem.pointRefund);
    }

    if (prevProps.isFetchingUser !== isFetchingUser && !isFetchingUser) {
      // this.togglePurchaseModal();
      if (selectedType === 'pastVideos' && !!selectedContentId) {
        getVideoByIdFromContent(selectedContentId);
      } else if (selectedType === 'pastProjectVideo' && !!selectedContentId) {
        getProjectContentById(selectedContentId);
      } else if (selectedType === 'eaProgram' && !!selectedContentId) {
        getEAById(selectedContentId);
      }
    }

    if (
      (prevProps.isFetchingVideoByIdFromContent !==
        isFetchingVideoByIdFromContent &&
        !isFetchingVideoByIdFromContent) ||
      (prevProps.isFetchingProjectContentById !==
        isFetchingProjectContentById &&
        !isFetchingProjectContentById) ||
      (prevProps.isFetchingEAById !== isFetchingEAById && !isFetchingEAById)
    ) {
      this.togglePurchaseModal();
    }

    if (isPurchaseModalVisible) {
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'static';
    }
  }

  getPurchases = (id: string) => {
    const { userId, fetchPurchases } = this.props;

    this.setState(
      {
        selectedContentId: id,
        selectedDownloadContent: id,
      },
      () => fetchPurchases(userId),
    );
  };

  handleOnPressPurchase = (id: string) => {
    const {
      userId,
      purchases,
      onPressPurchase,
      selectedType,
      getUser,
    } = this.props;
    const purchasedItem = purchases[`${userId}_${id}`];
    this.setState({ isPurchased: !!purchasedItem });
    if (purchasedItem && selectedType === 'pastVideos') {
      this.setState({ isPurchaseModalVisible: false }, () =>
        onPressPurchase(id),
      );
    } else {
      getUser(userId);
    }
  };

  handleOnPressPurchaseContent = () => {
    const { onPressPurchase, selectedType } = this.props;
    const { selectedContentId, isPurchased } = this.state;

    if (selectedType === 'pastVideos' && selectedContentId) {
      if (isPurchased && selectedType) {
      } else {
        this.setState({ isPurchaseModalVisible: false }, () =>
          onPressPurchase(selectedContentId),
        );
      }
    } else {
      if (selectedContentId && !isPurchased) {
        const fileInfo = this.getFileInfoForDownload();
        onPressPurchase(selectedContentId, fileInfo.fileURL, fileInfo.title);
      } else {
        this.downloadProjectFile();
      }
    }
  };

  setToastState = (discount: number) => {
    const toastTitle = `${discount}${words.pointsWereRefunded}`;
    this.setState(() => ({ toastTime: Date.now(), toastTitle }));
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFileInfoForDownload = (): { fileURL?: any; title: string } => {
    const { contents } = this.props;
    const { selectedContentId } = this.state;
    const fileInfo = contents.find(
      content => selectedContentId === content.id,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as { fileURL?: any; title: string };

    return fileInfo;
  };

  downloadProjectFile = () => {
    const { onDownloadFile } = this.props;
    const fileInfo = this.getFileInfoForDownload();
    onDownloadFile(fileInfo.fileURL, fileInfo.title);
  };

  togglePurchaseModal = () =>
    this.setState({
      isPurchaseModalVisible: !this.state.isPurchaseModalVisible,
    });

  render = (): React.ReactElement => {
    const {
      onSelectContentType,
      contentTitle,
      contents,
      userPoints,
      onPressPurchasePoints,
      selectedType,
      purchases,
      userId,
      contentTypes,
      navigateToManualContentViewer,
      isFetchingVideos,
      isFetchingProjectContents,
      isFetchingEAPrograms,
      isPurchasingContent,
      isFetchingVideoByIdFromContent,
      isDownloadingProjectContent,
      isDownloadingEAContent,
      isFetchingProjectContentById,
      isFetchingEAById,
      isFetchingPurchases,
      isFetchingUser,
    } = this.props;
    const {
      isPurchaseModalVisible,
      selectedContentId,
      isPurchased,
      toastTime,
      toastTitle,
    } = this.state;
    // const contentsList = Object.values(contents);
    const selectedContent = contents.find(
      content => selectedContentId === content.id,
    );

    return (
      <Container modalShowing={isPurchaseModalVisible || false}>
        {toastTitle ? (
          <Toast
            type="reward"
            title={toastTitle}
            message=""
            toastKey={toastTime}
          />
        ) : null}
        {isPurchaseModalVisible && selectedContentId ? (
          <PurchaseModal
            userPoints={userPoints}
            selectedPurchaseContent={selectedContent || contents[0]}
            onPurchaseContent={this.handleOnPressPurchaseContent}
            onPurchasePoints={onPressPurchasePoints}
            onPressCancel={this.togglePurchaseModal}
            isPurchasingContent={
              isPurchasingContent ||
              isDownloadingProjectContent ||
              isDownloadingEAContent
            }
            isPurchased={isPurchased}
          />
        ) : null}
        <ContentListHeader
          onPressSelect={onSelectContentType}
          contentTitle={contentTitle}
          selectedType={selectedType}
          contentTypes={contentTypes}
        />
        <ContentList
          contentType={selectedType}
          purchases={purchases}
          userId={userId}
          contents={contents}
          onPressPurchase={this.getPurchases}
          navigateToManualContentViewer={navigateToManualContentViewer}
          isFetchingVideos={isFetchingVideos}
          isFetchingProjectsContents={isFetchingProjectContents}
          isFetchingEAPrograms={isFetchingEAPrograms}
          modalShowing={isPurchaseModalVisible && selectedContentId !== ''}
          selectedContentId={selectedContentId}
          isFetchingVideoByIdFromContent={isFetchingVideoByIdFromContent}
          isFetchingProjectContentById={isFetchingProjectContentById}
          isFetchingEAById={isFetchingEAById}
          isFetchingPurchases={isFetchingPurchases}
          isFetchingUser={isFetchingUser}
        />
      </Container>
    );
  };
}
